import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Link } from 'gatsby'
import Operations from './Operations'

export default function Resources({ resources }) {
  if (!resources || resources.length === 0) {
    return null
  }
  return (
    <>
      {resources.map((resource, index) => {
        resource.description = resource.description || ''
        return (
          <div className="dax-resource" id={resource.name} key={index}>
            <header className="dax-topic-resource">
              <h2 className="dx-anchor">
                <Link
                  className="dx-anchor__icon"
                  to={`#${resource.name}`}
                  aria-hidden="true"
                />
                {resource.title} <small>(resource group)</small>
              </h2>

              <div className="dax-preamble">
                <ReactMarkdown
                  source={resource.description}
                  escapeHtml={false}
                  skipHtml={false}
                />
              </div>
            </header>

            <Operations operations={resource.operations} />
          </div>
        )
      })}
    </>
  )
}
